/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import fetch from "../../../api-client";
import type { RequestConfig, ResponseErrorConfig } from "../../../api-client";
import type { ProjectTemplatesControllerFindForProjectQueryResponse, ProjectTemplatesControllerFindForProjectPathParams, ProjectTemplatesControllerFindForProjectQueryParams, ProjectTemplatesControllerFindForProject401, ProjectTemplatesControllerFindForProject403 } from "../../models/checklistsController/ProjectTemplatesControllerFindForProject";
import type { QueryKey, QueryClient, QueryObserverOptions, UseQueryResult } from "@tanstack/react-query";
import { projectTemplatesControllerFindForProject } from "../../clients/checklistsService/projectTemplatesControllerFindForProject";
import { queryOptions, useQuery } from "@tanstack/react-query";
export const projectTemplatesControllerFindForProjectQueryKey = (projectId: ProjectTemplatesControllerFindForProjectPathParams["projectId"], params: ProjectTemplatesControllerFindForProjectQueryParams = {}) => [{
  url: '/api/v1/project-templates/:projectId',
  params: {
    projectId: projectId
  }
}, ...(params ? [params] : [])] as const;
export type ProjectTemplatesControllerFindForProjectQueryKey = ReturnType<typeof projectTemplatesControllerFindForProjectQueryKey>;
export function projectTemplatesControllerFindForProjectQueryOptions(projectId: ProjectTemplatesControllerFindForProjectPathParams["projectId"], params?: ProjectTemplatesControllerFindForProjectQueryParams, config: Partial<RequestConfig> & {
  client?: typeof fetch;
} = {}) {
  const queryKey = projectTemplatesControllerFindForProjectQueryKey(projectId, params);
  return queryOptions<ProjectTemplatesControllerFindForProjectQueryResponse, ResponseErrorConfig<ProjectTemplatesControllerFindForProject401 | ProjectTemplatesControllerFindForProject403>, ProjectTemplatesControllerFindForProjectQueryResponse, typeof queryKey>({
    enabled: !!projectId,
    queryKey,
    queryFn: async ({
      signal
    }) => {
      config.signal = signal;
      return projectTemplatesControllerFindForProject(projectId, params, config);
    }
  });
}

/**
 * @description Returns checklist templates tagged as project-level that are available for the given project. Includes templates scoped to the project's parent team and organization, plus global project-level templates. Respects activation status.
 * @summary Get project-level templates available for a project
 * {@link /api/v1/project-templates/:projectId}
 */
export function useProjectTemplatesControllerFindForProject<TData = ProjectTemplatesControllerFindForProjectQueryResponse, TQueryData = ProjectTemplatesControllerFindForProjectQueryResponse, TQueryKey extends QueryKey = ProjectTemplatesControllerFindForProjectQueryKey>(projectId: ProjectTemplatesControllerFindForProjectPathParams["projectId"], params?: ProjectTemplatesControllerFindForProjectQueryParams, options: {
  query?: Partial<QueryObserverOptions<ProjectTemplatesControllerFindForProjectQueryResponse, ResponseErrorConfig<ProjectTemplatesControllerFindForProject401 | ProjectTemplatesControllerFindForProject403>, TData, TQueryData, TQueryKey>> & {
    client?: QueryClient;
  };
  client?: Partial<RequestConfig> & {
    client?: typeof fetch;
  };
} = {}) {
  const {
    query: queryConfig = {},
    client: config = {}
  } = options ?? {};
  const {
    client: queryClient,
    ...queryOptions
  } = queryConfig;
  const queryKey = queryOptions?.queryKey ?? projectTemplatesControllerFindForProjectQueryKey(projectId, params);
  const query = useQuery({
    ...projectTemplatesControllerFindForProjectQueryOptions(projectId, params, config),
    queryKey,
    ...queryOptions
  } as unknown as QueryObserverOptions, queryClient) as UseQueryResult<TData, ResponseErrorConfig<ProjectTemplatesControllerFindForProject401 | ProjectTemplatesControllerFindForProject403>> & {
    queryKey: TQueryKey;
  };
  query.queryKey = queryKey as TQueryKey;
  return query;
}